<template>
  <section id="winning" v-if="ready">
    <b-container fluid>
      <b-row class="header">
        <b-card overlay :img-src="require(`../../assets/images/winning/background-top.jpg`)" img-alt="Prepack Planner Background" text-variant="white">
          <div class="aspect-ratio"></div>

          <parallax id="surfer"><b-img fluid :src="require(`../../assets/images/winning/toplayer.png`)"></b-img></parallax>

          <b-card-text class="headline">
            <h1 v-bind:class="{ blur: blurheadline }"><br /><span>Winning</span></h1>
          </b-card-text>
        </b-card>
      </b-row>

      <div class="content-section">
        <div class="row device">
          <div class="col-12">
            <h2><span>Connecting</span> <br />Electrical professionals to 3M products</h2>
          </div>
          <div class="col-md-6">
            <p>Shhh… It really wasn’t a secret at all for current users of 3M Electrical products. 3M product reliability and brand loyalty was not a new concept in electrical markets. Our campaign rewarded current 3M Electrical product users with instant and grand prize giveaways, but it also managed to spark new interest via incentive-based product trial.</p>
          </div>
          <div class="col-md-6">
            <p>In-store displays promoted the contest at the POP level while we drove an online social media campaign supported by video content that was all produced in-house. The campaign’s success led to a refreshed version the following year with a fun new twist on the creative direction.</p>
          </div>

          <div class="col-md-12">
            <b-img data-aos="fade-up" fluid :src="require(`../../assets/images/winning/UTS-grouping.png`)"></b-img>
            <b-img class="behindcomp" fluid :src="require(`../../assets/images/winning/plug.svg`)"></b-img>
          </div>
        </div>

        <div class="row treatments">
          <div class="col-12 col-lg-5 bannerbug">
            <b-img class="plug" fluid :src="require(`../../assets/images/winning/behindcomp.svg`)"></b-img>
            <b-img data-aos="fade-right" fluid :src="require(`../../assets/images/winning/Group 27486.png`)"></b-img>
          </div>
          <div class="col-12 col-lg-7">
            <div class="pop">
              <h3>Uncover POP treatments.</h3>
              <p>To generate awareness among MRO’s audience in-store, a set of POP initiatives were deployed.</p>
            </div>
            <div class="row stat" data-aos="fade-left">
              <div class="col-12 shrink">
                <h4>
                  4<sup>.93<span>%</span></sup> <span class="participation">participation <br />rate</span>
                </h4>
                <b-img class="participation-icon" fluid :src="require(`../../assets/images/winning/Group 27487.svg`)"></b-img>
              </div>
            </div>
            <div class="row stat" data-aos="fade-left">
              <div class="col-12 shrink">
                <h4>
                  <sup class="money">$</sup>10 <sup class="mm">MM</sup> <span class="sales"><strong>increase</strong> <br />in sales</span>
                </h4>
                <b-img class="sales-icon" fluid :src="require(`../../assets/images/winning/Group 27488.svg`)"></b-img>
              </div>
            </div>
          </div>
        </div>
      </div>

      <b-card class="footer" overlay :img-src="require(`../../assets/images/winning/UTS3_106-2.png`)" img-alt="Uncover a secret" text-variant="white">
        <div class="row additions">
          <div class="col-12 content first" data-aos="fade-right">
            <h3>PINs for wins.</h3>
            <p>Every specially marked product contained a wafer with a PIN inside. The PIN was then to be entered on the campaign microsite. Many entries won instant prizes and one Grand prize of $10,000 was awarded at the conclusion of the campaign.</p>
          </div>

          <div class="col-12 content" data-aos="fade-right">
            <h3>Boosting social with video.</h3>
            <p>Leveraging YouTube as our video platform to help spread the word about the Uncover the Secret campaign, we were able to reach a broad audience. A full video production team was assembled to plan, shoot and edit engaging promotional videos.</p>
            <b-img class="clickme" fluid @click="$bvModal.show('modal-footer-lg')" :src="require(`../../assets/images/winning/button.svg`)"></b-img>
          </div>
        </div>
      </b-card>

      <b-modal id="modal-footer-lg" size="xl" centered modal-cancel="dude">
        <div class="modal-body-full">
          <iframe src="https://player.vimeo.com/video/938625785?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&title=0&byline=0&portrait=0&share=0" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write" style="width:100%;height:100%;" title="Trade In Trade Up Instructional Video"></iframe>
        </div>
      </b-modal>
    </b-container>

    <div class="container-fluid otherwork" :class="{ 'section-animation-in': hover }">
      <h4>See work <span>that matters.</span></h4>

      <div class="preview-text-container" @click="toggleActive" :class="{ 'additional-class': activeStates[0] }">
        <div class="image-container">
          <div class="divide"></div>
          <router-link to="/work/universe" class="content">
            <span class="projecttype dark">APP DEVELOPMENT</span>
            <span class="otherprojecthead dark">Unilux VFC</span>
            <span class="changeme dark">Control your universe.</span>
          </router-link>

          <img class="fade-in-image" :src="require(`../../assets/images/universe-other.png`)" alt="Your image" />
        </div>
      </div>

      <div class="preview-text-container" @click="toggleActive" :class="{ 'additional-class': activeStates[1] }">
        <div class="image-container">
          <div class="divide"></div>
          <router-link to="/work/clarity" class="content">
            <span class="projecttype">CAMPAIGN DEVELOPMENT</span>
            <span class="otherprojecthead">3M Clarity</span>
            <span class="changeme">Smiles for miles.</span>
          </router-link>

          <img class="fade-in-image" :src="require(`../../assets/images/clarity-other.png`)" alt="Your image" />
        </div>
      </div>

      <div class="preview-text-container" @click="toggleActive" :class="{ 'additional-class': activeStates[2] }">
        <div class="image-container">
          <div class="divide"></div>
          <router-link to="/work/surface" class="content">
            <span class="projecttype dark">CAMPAIGN DEVELOPMENT</span>
            <span class="otherprojecthead dark">3M Food Safety</span>
            <span class="changem dark">See beyond the surface.</span>
          </router-link>

          <img class="fade-in-image" :src="require(`../../assets/images/surface-other.png`)" alt="Your image" />
        </div>
      </div>

      <div class="preview-text-container" @click="toggleActive" :class="{ 'additional-class': activeStates[3] }">
        <div class="image-container">
          <div class="divide"></div>
          <router-link to="/work/higher" class="content">
            <span class="projecttype">CAMPAIGN DEVELOPMENT</span>
            <span class="otherprojecthead">3M Fall Protection</span>
            <span class="changeme">Bottom lines to new heights.</span>
          </router-link>
          <img class="fade-in-image" :src="require(`../../assets/images/higher-other.png`)" alt="Your image" />
        </div>
      </div>

      <div class="preview-text-container" @click="toggleActive" :class="{ 'additional-class': activeStates[4] }">
        <div class="image-container">
          <div class="divide"></div>
          <router-link to="/work/prepack-planner" class="content">
            <span class="projecttype">APP DEVELOPMENT</span>
            <span class="otherprojecthead">McCormick Display Strategy</span>
            <span class="changeme">Displays to order.</span>
          </router-link>

          <img class="fade-in-image" :src="require(`../../assets/images/prepack-other.png`)" alt="Your image" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Parallax from "vue-parallaxy";

//AOS Animations
import AOS from "aos";
import "aos/dist/aos.css";

export default {
  components: {
    Parallax,
  },
  data() {
    return {
      hover: false,
      ready: false,
      blurheadline: false,
      isActive: false,
      activeStates: {},
    };
  },
  metaInfo: {
    titleTemplate: "Connecting Electrical Professionals to 3M products | Branton  — a Creation Company.",
    meta: [
      {
        name: "Our Work",
        content: "3M's Uncover the Secret, created by Branton. Our campaign rewarded current 3M Electrical product users with instant and grand prize giveaways, but it also managed to spark new interest via incentive-based product trial. ",
      },
    ],
  },
  methods: {
    initializeObservers() {
      const elements = this.$el.querySelectorAll(".preview-text-container");
      if (elements.length === 0) {
        console.error("No elements found");
        return;
      }
      elements.forEach((element, index) => {
        const observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              console.log(`Element ${index} is intersecting: ${entry.isIntersecting}`);
              this.$set(this.activeStates, index, entry.isIntersecting);
            });
          },
          { threshold: 1 }
        );

        observer.observe(element);
      });
    },
    handleScroll() {
      if (window.scrollY > 200) {
        this.blurheadline = true;
      } else {
        this.blurheadline = false;
      }
    },
    toggleActive(event) {
      this.isActive = !this.isActive;
      event.currentTarget.classList.toggle("active");
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initializeObservers();
    });

    this.ready = true;

    this.$gtag.pageview({
      page_path: "/work/winning",
    });

    if (this.ready) {
      AOS.init();
      AOS.refresh();
      setTimeout(function() {
        // Your timeout function here
      }, 100); // Adjust timeout as needed
    }
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style lang="scss">
@import "@/assets/css/winning.scss";

div#surfer {
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 100;
}

img.clickme.img-fluid {
  cursor: pointer !important;
  user-select: initial !important;
  pointer-events: all !important;
}
</style>
